// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1348F","consentsList":"PatientConsents_consentsList__2VADl","consentsListEmpty":"PatientConsents_consentsListEmpty__1vhvC"};